/*
 * Project: enviolo AWS back-end
 * File: QrMapping
 * File Created: Wednesday, 23rd March 2022 2:27:10 pm
 * Author: Enzo Ciriello (enzo@qbus-ict.nl)
 * -----
 * Last Modified: Wednesday, 23rd March 2022 2:30:01 pm
 * Modified By: Enzo Ciriello (enzo@qbus-ict.nl>)
 * -----
 * Copyright 2021 - 2022 Qbus B.V., Qbus B.V.
 */
/*
NOTES:
ahiType: "Pure/Pro", (add cadence increment)
canProtocol: "Custom" (value 3 add CAN Fields 1-7 and Can Speed)
----
*/
export const QrMapping = {
  firstName: {value: 77, label: "First Name", orderToSend: -1},
  lastName: {value: 78, label: "Last Name", orderToSend: -1},
  streetName: {value: 79, label: "Street Name", orderToSend: -1},
  houseNumber: {value: 80, label: "House Number", orderToSend: -1},
  postalCode: {value: 81, label: "Postal Code", orderToSend: -1},
  city: {value: 82, label: "City", orderToSend: -1},
  country: {value: 83, label: "Country", orderToSend: -1},
  cadenceSpeed: {value: 4, label: "Cadence Speed", orderToSend: -1},
  wheelSpeed: {value: 5, label: "Wheel Speed", orderToSend: -1},
  vehicleSpeed: {value: 6, label: "Vehicle Speed", orderToSend: -1},
  temperatureHi: {value: 7, label: "Temperature HI", orderToSend: -1},
  batteryVoltage: {value: 8, label: "Battery Voltage", orderToSend: -1},
  lifetimeDistanceHi: {value: 10, label: "Lifetime Distance HI 10", orderToSend: -1},
  calibrationStatus: {value: 15, label: "Calibration Status", orderToSend: -1},
  calibrate: {value: 16, label: "Calibrate", orderToSend: -1},
  bikeModelYear: {value: 88, label: "Bike Model Year", orderToSend: 3},
  internalGearHub: {value: 90, label: "Bike CVP Type", orderToSend: 8},
  trafficLightRatio: {value: 89, label: "Traffic Light Ratio", factor: 100},
  numberOfTeethRearSprocket: {value: 44, label: "Gear Cog Teeth"},
  numberOfTeethFrontChainwheel: {value: 45, label: "Gear Crank Teeth"},
  wheelCircumference: {value: 46, label: "Wheel Circumference 46"},
  lifetimeDistance: {value: 47, label: "Lifetime Distance"},
  timeBeforeSleepMinutes: {value: 48, label: "Time before systems sleeps"},
  brownoutVoltage: {value: 49, label: "Brownout Voltage"},
  bikeDateManufactured: {value: 62, label: "Bike Date Manufactured"},
  bikeModelName: {value: 63, label: "Bike Model Name"},
  bikeBrand: {value: 64, label: "Bike Brand"},
  bikeSaleDate: {value: 65, label: "Bike Sale Date"},
  operationMode: {value: 22, label: "Operation Mode"},
  ratioSetpoint: {value: 23, label: "Ratio Setpoint"},
  cadenceSetPoint: {value: 24, label: "Cadence Setpoint"},
  minCadence: {value: 25, label: "Min Cadence"},
  maxCadence: {value: 26, label: "Max Cadence"},
  driveTypeRatio: {value: 92, label: "Drive Type Ratio"},
  eBikeDriveSystem: {value: 91, label: "Drive Type"},
  activeProfile: {value: 30, label: "Current Profile"},
  currentVariant: {value: 32, label: "Current Varriant"},
  canProtocol: {value: 72, label: "CAN Protocol"},
  envioloGearPropertyOne: {value: 53, label: "CAN ID1", type: "hex"},
  envioloGearPropertyTwo: {value: 54, label: "CAN ID2", type: "hex"},
  envioloDuConfiguration: {value: 55, label: "CAN ID3", type: "hex"},
  envioloDuControl: {value: 56, label: "CAN ID4", type: "hex"},
  duDfuControl: {value: 57, label: "CAN ID5", type: "hex"},
  duDfuData: {value: 58, label: "CAN ID6", type: "hex"},
  gearDfuResponse: {value: 96, label: "CAN ID7", type: "hex"},
  canProtocolBaudRate: {value: 52, label: "CAN Speed"},
  cadenceIncrement: {value: 97, label: "Cadence Increment"},
  limpHomeRatio: {value: 50, label: "Limp Home Ratio", factor: 100}
}